import { Controller } from "@hotwired/stimulus"

// Выбор товара с подсказками для одной строки формы.
//
// В отличие от order-form, который управляет всей таблицей продажи и считает
// итоги, этот контроллер отвечает ровно за одно поле: показать подсказки,
// записать выбранный вариант в скрытый input. Вешается на каждую строку.
export default class extends Controller {
  static targets = ["query", "variantId", "suggest", "price", "repricing", "oldPrice"]
  static values = { url: String, scope: { type: String, default: "purchase" } }

  connect() {
    this.closeOnOutsideClick = this.onOutsideClick.bind(this)
    document.addEventListener("click", this.closeOnOutsideClick)
  }

  disconnect() {
    clearTimeout(this.timer)
    document.removeEventListener("click", this.closeOnOutsideClick)
  }

  query() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.search(), 200)
  }

  async search() {
    const term = this.queryTarget.value.trim()
    const url = `${this.urlValue}?scope=${encodeURIComponent(this.scopeValue)}&q=${encodeURIComponent(term)}`

    try {
      const response = await fetch(url, { headers: { Accept: "text/html" } })
      if (!response.ok) return
      this.suggestTarget.innerHTML = await response.text()
      this.suggestTarget.classList.remove("hidden")
    } catch {
      // Сеть моргнула — оставляем прошлые подсказки, а не пустой список.
    }
  }

  pick(event) {
    const item = event.currentTarget
    this.variantIdTarget.value = item.dataset.variantId
    this.queryTarget.value = item.dataset.title
    this.close()

    // Цена в накладной — это цена продажи, и обычно она та же, что у товара.
    // Подставляем текущую, чтобы вбивать пришлось только когда она изменилась.
    if (this.hasPriceTarget) {
      this.currentPrice = item.dataset.price
      this.priceTarget.value = this.currentPrice
      this.priceChanged()
    }

    // Приход набирают подряд: после товара курсор нужен в количестве.
    this.element.querySelector("[data-role='quantity']")?.focus()
  }

  // Разошлась ли цена в накладной с текущей ценой товара.
  priceChanged() {
    if (!this.hasRepricingTarget) return

    const current = parseFloat(this.currentPrice)
    const entered = parseFloat(this.priceTarget.value)
    const differs = Number.isFinite(current) && Number.isFinite(entered) && entered !== current

    this.repricingTarget.classList.toggle("hidden", !differs)
    if (differs) this.oldPriceTarget.textContent = current.toFixed(2)
  }

  keydown(event) {
    if (event.key === "Escape") this.close()
  }

  // Пока товар не выбран заново, форма не должна отправить старый вариант
  // с новым текстом в поле.
  invalidate() {
    this.variantIdTarget.value = ""
    this.currentPrice = null
    if (this.hasRepricingTarget) this.repricingTarget.classList.add("hidden")
  }

  close() {
    this.suggestTarget.classList.add("hidden")
    this.suggestTarget.innerHTML = ""
  }

  onOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close()
  }
}
